// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type ComponentType } from 'react';
import Breadcrumb from '@atlassian/jira-breadcrumbs/src/breadcrumb/component.tsx';
import PageHeader from '@atlassian/jira-common-components-page-header';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import commonMessages from '@atlassian/jira-servicedesk-common/src/i18n';
import DeprecationMessage from '../deprecation-message';
import messages from './messages';
import { PageDescription, SettingsContainer, ButtonsContainer } from './styled';

export type Props = {
	hasRules: boolean;
	showActions: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	SettingsDialogComponent: ComponentType<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	MisconfiguredSettingsDialogComponent: ComponentType<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	AddButtonComponent: ComponentType<any>;
	automationUrl: string;
	onAddRule: () => void;
	intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
class SummaryHeader extends PureComponent<Props> {
	renderRuleActions() {
		const { onAddRule, SettingsDialogComponent, AddButtonComponent, showActions } = this.props;
		return showActions ? (
			<ButtonsContainer>
				<SettingsContainer>
					<SettingsDialogComponent />
				</SettingsContainer>
				<AddButtonComponent onClick={onAddRule} />
			</ButtonsContainer>
		) : undefined;
	}

	getPageDescription() {
		const {
			intl: { formatMessage },
		} = this.props;
		return (
			<>
				<DeprecationMessage />
				<PageDescription>{formatMessage(messages.pageDescription)}</PageDescription>
			</>
		);
	}

	render() {
		const {
			intl: { formatMessage },
			hasRules,
			MisconfiguredSettingsDialogComponent,
			automationUrl,
		} = this.props;

		const bottomBar = hasRules ? this.getPageDescription() : undefined;
		const pageHeader = (
			<PageHeader truncateTitle actions={this.renderRuleActions()} bottomBar={bottomBar}>
				{formatMessage(commonMessages.automation)}
				<MisconfiguredSettingsDialogComponent />
			</PageHeader>
		);

		return (
			<Breadcrumb
				breadcrumb={{
					href: automationUrl,
					text: formatMessage(commonMessages.automation),
				}}
			>
				{pageHeader}
			</Breadcrumb>
		);
	}
}

export default injectIntl(SummaryHeader);
